import http from "./httpService";
import config from "./config";



export const webinars = () => {
    return http.get(
        `${config.apiAddress}webinars/`
    );
};

export const timerCountDown = () => {
    return http.get(
        `${config.apiAddress}timer/`
    );
};


export const webinar = slug => {
    return http.get(
        `${config.apiAddress}webinars/${slug}`
    );
};

export const webinarOff = (slug,offCode) => {
    return http.get(
        `${config.apiAddress}webinarOff/${slug}/${offCode}`
    );
};



export const myWebinars = (username) => {
    console.log(username);
    return http.get(
        `${config.apiAddress}myWebinars/${username}`
    );
};
export const myFiles = (username) => {
    return http.get(
        `${config.apiAddress}myFiles/${username}`
    );
};


export const isUserRegisterWebinar = (username,slug) => {
    return http.get(
        `${config.apiAddress}isUserRegisterWebinar/${username}/${slug}`
    );
};

export const isUserBuyedWebinar = (username,slug) => {
    return http.get(
        `${config.apiAddress}isUserBuyedWebinar/${username}/${slug}`
    );
};



export const webinarFiles = (slug) => {
    return http.get(
        `${config.apiAddress}webinarFiles/${slug}`
    );
};



export const webinarVisit = (slug) => {
    return http.get(
        `${config.apiAddress}webinarVisit/${slug}`
    );
};


export const studentNumber = (slug) => {
    return http.get(
        `${config.apiAddress}studentNumber/${slug}`
    );
};



export const totalOff = () => {
    return http.get(
        `${config.apiAddress}totalOff/`
    );
};